// @flow

import {Tag} from 'docs/util';
import type {MarkdocTagRegistration} from 'docs/markdoc';
import {getMarkdocElementSchema} from '../getMarkdocElementSchema';

export const MarkdocTagExternalLinks: MarkdocTagRegistration = {
  tag: 'markdoc-tag-external-links',
  description: 'Link to usages and the implementation of a given markdoc tag',
  component: 'MarkdocTagExternalLinks',
  attributes: {
    tag: {
      type: String,
      description:
        'The name of a markdoc tag as defined in the markdoc registration.',
      required: true,
    },
  },
  render(node, config) {
    const tagName = (node.attributes.tag: any);
    const nodeName = (node.attributes.node: any);
    const tagSchema = getMarkdocElementSchema(tagName || nodeName);
    return new Tag(this.tag, {tagSchema, tagName});
  },
};
